import React from 'react';
import styles from './footer.module.scss';

const Footer = () => {
  const checkBottom = () => {
    const intViewportHeight = window.innerHeight;
    return intViewportHeight < 756 ? 'auto' : 0;
  };

  return (
    <div className={styles.footer} style={{ bottom: checkBottom() }}>
      <div className={styles.container}>
        <div className="">
          <p className={styles.UserManulText}>
            Naudotojo instrukciją galite rasti
            <span>
              {' '}
              <a href=" https://ilte.lt/wp-content/uploads/ASAP-web-instrukcija-04.11.pdf">
                čia
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
